import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { ProjectType } from '../../models/api.models';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-master-user-list',
  standalone: true,
  imports: [CommonModule, TableModule, ToastModule, FormsModule, TagModule],
  providers: [MessageService],
  templateUrl: './master-user-list.component.html',
  styles: [`
    .master-card {
      background: white;
      border-top: 4px solid #1e293b;
    }
  `]
})
export class MasterUserListComponent implements OnInit {
  users: any[] = [];
  loading: boolean = false;
  selectedClient: ProjectType = ProjectType.SVN;
  projectTypes = [
    { label: 'SVN', value: ProjectType.SVN },
    { label: 'SOVRN', value: ProjectType.SOVRN },
    { label: 'CAPITAL', value: ProjectType.CAPITAL }
  ];

  constructor(
    private apiService: ApiService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers(): void {
    this.loading = true;
    this.apiService.getUsersByClientMaster(this.selectedClient).subscribe({
      next: (response) => {
        this.users = response && response.data ? response.data : [];
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load master users'
        });
        this.loading = false;
      }
    });
  }

  switchClient(client: ProjectType): void {
    this.selectedClient = client;
    this.loadUsers();
  }
}
